import React from "react";
import "./gallary.css";
import Boreails2022 from "./2022/borealis22"; //2022
import Boreails2019 from "./2019/borealis19"; //2019
import Boreails2018 from "./2018/borealis18"; //2018
import Boreails2017 from "./2017/borealis17"; //2017

export default function Gallary() {
  return (
    <div className="Gallarwrapper">
      <div className="2019">
        <Boreails2022 />
      </div>

      <div className="2019">
        <Boreails2019 />
      </div>
      <br />
      <br />

      <div className="2018">
        <Boreails2018 />
      </div>

      <div className="2017">
        <Boreails2017 />
      </div>
      <br />
      <br />

      <p>All Borealis Images are completed.....</p>
    </div>
  );
}
